
    <h1 mat-dialog-title>Enter New Sub</h1>
    <div mat-dialog-content>
      <form [formGroup]="subForm">
        <mat-form-field style="width:100%">
          <mat-label>Sub Name</mat-label>
          <input matInput placeholder="Enter sub name" formControlName="subName" />
          <mat-error *ngIf="subForm.get('subName').invalid">Sub name is required</mat-error>
        </mat-form-field>
      </form>
    </div>
    <div mat-dialog-actions>
      <button mat-button (click)="onCancel()">Cancel</button>
      <button mat-button [disabled]="subForm.invalid" (click)="onConfirm()">Confirm</button>
    </div>
  